// extracted by mini-css-extract-plugin
export default {"form_body":"issue_form_body__HYwkB","form":"issue_form__0SePo","form__label":"issue_form__label__twhLb","form__input":"issue_form__input__YgOk1"};